import { debounce } from 'underscore';
import { getFilterStateWithDateDefaults } from 'web-interactives-dashboard-ui/selectors/filterSelectors';
import { getPathParams, getUrlQueryString } from 'web-interactives-dashboard-ui/selectors/urlSelectors';
import { getBaseRoute } from 'web-interactives-dashboard-ui/selectors/appStateSelectors';
import { fetchDataForAnalyze } from 'web-interactives-dashboard-ui/actions/AnalyzeActions';
import router from 'web-interactives-dashboard-ui/history';
const createDebouncedFilterFetch = fetchFunc => debounce(fetchFunc, 500);
const applyFiltersMiddleware = store => {
  const debouncedFetchAnalytics = createDebouncedFilterFetch(() => store.dispatch(fetchDataForAnalyze()));
  return next => action => {
    const prevState = store.getState();
    const result = next(action);
    const nextState = store.getState();
    const pathParams = getPathParams(nextState);
    const baseRoute = getBaseRoute(nextState);
    if (getUrlQueryString(prevState) !== getUrlQueryString(nextState)) {
      router.navigateTo(`/${pathParams.join('/')}`, getUrlQueryString(nextState));
    }
    const prevFilterState = getFilterStateWithDateDefaults(prevState);
    const nextFilterState = getFilterStateWithDateDefaults(nextState);
    if (['details', 'analyze'].includes(baseRoute) && prevFilterState !== nextFilterState) {
      debouncedFetchAnalytics();
    }
    return result;
  };
};
export default applyFiltersMiddleware;